export default __webpack_public_path__ + "static/circle-wow-face-7df99a9f993b1ab0d4ad10c1324cd6a8.png";